import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../app/hooks/useAuth'
import { UserRoleEnum } from '@/app/services/usersService/user'

interface RoleGuardProps {
  role?: UserRoleEnum
}

export function RoleGuard({ role }: RoleGuardProps) {
  const { user } = useAuth()

  enum roleGrade {
    SUPPORT,
    USER,
    LEADER,
    MANAGER,
    SUPERVISOR,
    ADMIN,
    SUPER_ADMIN,
  }

  if (!user?.role) return

  if (role && roleGrade[role] > roleGrade[user.role])
    return (
      <Navigate
        to={
          [UserRoleEnum.SUPPORT].includes(user.secondRole)
            ? '/support'
            : '/transacoes'
        }
        replace
      />
    )

  return <Outlet />
}
